import { Flex } from 'antd'
import { FeatureItemProps } from '@/assets/content/products/type'
import CardList from './card-list'
import ImageList from './image-list'
import styles from './style.module.scss'

const COMPONENT_MAP = {
  'card-list': CardList,
  'image-list': ImageList,
} as const

export default function Features({ data }: { data: FeatureItemProps[] }) {
  if (!data?.length) return null

  return (
    <div className={styles.features}>
      <h2>Features</h2>
      <Flex vertical className={styles.featuresContent}>
        {data
          .filter(({ type }) => !!COMPONENT_MAP[type])
          .map(item => {
            const Component = COMPONENT_MAP[item.type]
            return <Component key={item.type} content={item.content as any} />
          })}
      </Flex>
    </div>
  )
}
